import React from "react";
import classNames from "classnames";
import { WebAppContext } from "./WAContainer";
export const WAMain: React.FC<{}> = ({ children }) => {
  let state = WebAppContext.useContainer();
  return (
    <main className="wa-main">
      <div
        className={classNames("wa-close-overlay", { show: state.open })}
        id="closeOverlay"
        onClick={() => state.setOpen(false)}
      ></div>
      {children}
    </main>
  );
};
